module.exports = __webpack_public_path__ + "media/promotional/helicopter-a8bf3194.jpeg";